import React from 'react';
import Hero from '../components/sections/Hero';

const Home: React.FC = () => {
  return (
    <>
      <Hero />
    </>
  );
};

export default Home; 